import React from 'react';
import TestimonialsMain from '../TestimonialsMain/TestimonialsMain';

const Testimonials = () => {
    return (
        <div>
            <TestimonialsMain />
        </div>
    );
};

export default Testimonials;